<button
  type="button"
  [attr.aria-label]="ariaLabel()"
  [disabled]="disabled()"
  class="sz-icon-button"
  [class.sz-icon-button--sm]="size() === 'sm'"
  [class.sz-icon-button--lime]="variant() === 'lime'"
  [class.sz-icon-button--danger-ghost]="variant() === 'danger-ghost'">
  <sz-icon [name]="icon()" [size]="iconSize()" />
</button>
